import { type BundleMachineGuard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether the add to bag run got at least one product into the bag.
 */
export const checkIfHasAddedProducts: BundleMachineGuard = (guardArgs) => {
  const { context } = guardArgs;

  return context.productAdds.added.length > 0;
};
